import $axios from "../api/accessor";
import { $api } from "../api/api";

export const CourierServices = {
  async getAllRegions() {
    let response = await $axios
      .get($api("regions"), {
        headers: {
          "Accept-Language": "az",
        },
      })
      .catch((err) => {
        return err.response;
      });
    return {
      data: response?.data ? response?.data : [],
      status: response?.status,
    };
  },

  async getCourierDetail(id: number) {
    let response = await $axios
      .get($api("get_CourierDetail", { id: id }), {
        headers: {
          "Accept-Language": "az",
        },
      })
      .catch((err) => {
        return err.response;
      });

    return {
      data: response?.data ? response.data : {},
      status: response?.status,
    };
  },

  async getAllPackages() {
    let response = await $axios
      .get($api("package"), {
        headers: {
          "Accept-Language": "az",
        },
      })
      .catch((err) => {
        return err.response;
      });
    return {
      data: response?.data ? response?.data : [],
      status: response?.status,
    };
  },
  async getPaymentType() {
    let response = await $axios
      .get($api("delivery_time"), {
        headers: {
          "Accept-Language": "az",
        },
      })
      .catch((err) => {
        return err.response;
      });
    return {
      data: response?.data ? response?.data : [],
      status: response?.status,
    };
  },
  async PostCourier(payload: any) {
    try {
      const response = await $axios.post($api("post_courier"), payload);
      return response;
    } catch (error: any) {
      throw error.response ? error.response.data : error.message;
    }
  },
  async getAllOrders(url?: string) {
    let response = await $axios
      .get(url || $api("get_allOrders"), {
        headers: {
          "Accept-Language": "az",
        },
      })
      .catch((err) => {
        return err.response;
      });

    return {
      data: response?.data ? response?.data : [],
      status: response?.status,
    };
  },
  async get_courierSetting() {
    let response = await $axios
      .get($api("get_courierSetting"), {
        headers: {
          "Accept-Language": "az",
        },
      })
      .catch((err) => {
        return err.response;
      });
    return {
      data: response?.data ? response?.data : [],
      status: response?.status,
    };
  },
  async getPaymentTypesByAreaId(area_id: number) {
    const url = $api("payment_types", { area_id });
    const response = await $axios.get(url, {
      headers: {
        "Accept-Language": "az",
      },
    });
    return response.data;
  },
  async Post_calculatedelivery_courier(payload: any) {
    try {
      const response = await $axios.post(
        $api("post_calculatedelivery_courier"),
        payload
      );
      return response;
    } catch (error: any) {
      throw error.response ? error.response.data : error.message;
    }
  },
};
